import React from 'react';
import connected from '../assets/sso/check.svg';
import notConnected from '../assets/sso/close.svg';

interface NetworkItemProps {
    logo: string;
    displayName: string;
    variant: 'status' | 'count';
    isConnected?: boolean;
    count?: number;
    totalCount?: number;
    sizeClass?: 'small' | 'medium';
}

const NetworkItem: React.FC<NetworkItemProps> = ({
    logo,
    displayName,
    variant,
    isConnected = false,
    count = 0,
    totalCount = 0,
    sizeClass = 'medium',
}) => {
    const logoSize = sizeClass === 'small' ? 'w-5' : 'w-[24px]';
    const textClass =
        sizeClass === 'small'
            ? 'text-small font-heavy text-gray'
            : 'text-[14px] font-medium text-gray';

    return (
        <div className="flex items-center justify-between gap-5">
            <img className={logoSize} src={logo} alt={`logo ${displayName.toLowerCase()}`} />
            <span className={`flex flex-1 ${textClass}`}>{displayName}</span>
            {variant === 'status' ? (
                <span>
                    {isConnected ? (
                        <img className="w-5" src={connected} alt="connected" />
                    ) : (
                        <img className="w-5" src={notConnected} alt="not connected" />
                    )}
                </span>
            ) : (
                <span
                    className={`px-[12px] py-[4px] rounded-[20px] text-white font-medium text-base ${
                        count === totalCount ? 'bg-status-complete' : 'bg-status-draft'
                    }`}
                >
                    {count} / {totalCount}
                </span>
            )}
        </div>
    );
};

export default NetworkItem;
